import React from "react";
import { connect } from "react-redux";
import { saveRemoteVpn } from "../../../services/facility/action";
import DeleteModel from "../../common/Model/deleteModel";

class VpnConnection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      facilityInfo: "",
      facilityEmail: "",
      vpnName: "",
      password: "",
      ipAddress: "",
      emrUserName: "",
      emrPassword: "",
      id: "",
      popUp: false,
      modelConfirm: false,
      model_text: ""
    };
  }

  closePop = () => {
    this.setState({
      popUp: false
    });
  };

  confirmOkay = () => {
    this.setState(
      {
        modelConfirm: true,
        popUp: false
      },
      () => {
        if (this.state.modelConfirm) {
          const {
            id,
            access_token,
            vpnName,
            password,
            ipAddress,
            emrUserName,
            emrPassword,
            facilityEmail,
            facilityInfo
          } = this.state;
          let Payload = {
            id,
            vpnName,
            password,
            ipAddress,
            emrUserName,
            emrPassword,
            facilityEmail,
            isDefault: true
          };

          this.props.saveRemoteVpn(access_token, Payload, facilityInfo);
        }
      }
    );
  };

  handleChange = e => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };
  componentDidMount() {
    let facilityInfo = this.props.profileDetails.commonUser.userId;
    let facilityEmail = this.props.profileDetails.commonUser.officeEmail;
    let access_token = this.props.loginDetails;

    this.setState({
      access_token,
      facilityInfo,
      facilityEmail
    });

    if (this.props.remoteAccessVpnDetails) {
      let data = this.props.remoteAccessVpnDetails.listVpnConnection;

      this.setState({
        id: data.id,
        vpnName: data.vpnName,
        password: data.password,
        ipAddress: data.ipAddress,
        emrUserName: data.emrUserName,
        emrPassword: data.emrPassword
      });
    }
  }

  saveRemoteVpn = e => {
    e.preventDefault();
    this.setState({
      popUp: true,
      model_text: "You want to set VPN as default connection"
    });
  };

  render() {
    const {
      vpnName,
      password,
      ipAddress,
      emrUserName,
      emrPassword
    } = this.state;

    return (
      <>
        <div className="cloudbased-emr">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>IP Address / URL for the VPN</label>
                <input
                  type="text"
                  value={ipAddress}
                  name="ipAddress"
                  onChange={this.handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>VPN Username</label>
                <input
                  type="text"
                  value={vpnName}
                  name="vpnName"
                  onChange={this.handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>VPN Password</label>
                <input
                  type="text"
                  value={password}
                  name="password"
                  onChange={this.handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>EMR Username</label>
                <input
                  type="text"
                  value={emrUserName}
                  name="emrUserName"
                  onChange={this.handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>EMR Password</label>
                <input
                  type="text"
                  value={emrPassword}
                  name="emrPassword"
                  onChange={this.handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 xs-center-align text-right">
            <button
              type="button"
              onClick={this.saveRemoteVpn}
              className="btnDefault"
            >
              Save
            </button>
          </div>
        </div>

        <DeleteModel
          text={this.state.model_text}
          status={this.state.popUp}
          closePop={this.closePop}
          confirmOkay={this.confirmOkay}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  loginDetails: state.commonReducer.loginDetails,
  profileDetails: state.commonReducer.profileDetails,
  emrOrVpnDetails: state.facilityReducer.emrOrVpnDetails,
  remoteAccessVpnDetails: state.facilityReducer.remoteAccessVpnDetails,
  getPractitionersStatus: state.facilityReducer.getPractitionersStatus,
  editPractitionerSuccess: state.facilityReducer.editPractitionerSuccess,
  deletePractitionerStatus: state.facilityReducer.deletePractitionerStatus
});

const mapDispatchToProps = dispatch => ({
  saveRemoteVpn: (token, Payload, facilityInfo) =>
    dispatch(saveRemoteVpn(token, Payload, facilityInfo))
  // addEmploye: (Payload, token) => dispatch(addEmploye(Payload, token)),
  //editPractitioner: (Payload, token) => dispatch(editPractitioner(Payload, token)),
  //deletePractitioner: (id, token) => dispatch(deletePractitioner(id, token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VpnConnection);
